module.exports = __webpack_public_path__ + "img/solana-small.f5626622.svg";